<template>
  <div v-if="homepage">
    <h3>BU Section</h3>
    <div class="h4 py-5">可新增/編輯BU Section</div>
    <div>
      <div class="collapse" v-for="(item, index) in homepage.sections" :key="index">
        <div class="collapse-head">
          <v-icon style="margin-right: 6px">keyboard_arrow_up</v-icon>
          <h3>BU {{ index+1 }}</h3>
          <v-spacer></v-spacer>
          <button class="btn square" style="margin-right: 10px" @click="deleteItem(item)">
            <v-icon color="ink-02-medium">delete</v-icon>
          </button>
          <button class="btn square" style="margin-right: 10px">
            <v-icon color="ink-02-medium" @click="upItem(item, index)">arrow_upward</v-icon>
          </button>
          <button class="btn square">
            <v-icon color="ink-02-medium" @click="downItem(item, index)">arrow_downward</v-icon>
          </button>
        </div>
        <div class="collapse-body">
          <div class="form-item d-flex pt-5">
            <label class="w-174px mr-6px flex-shrink-0 h4"
            ><h4>Title</h4></label
            >
            <div class="flex-grow-1 h4 mt-n2">
              <v-textarea
                v-model="item.title"
                outlined
                dense
              ></v-textarea>
            </div>
          </div>
          <div class="form-item d-flex pt-5">
            <label
              class="w-174px mr-6px flex-shrink-0 h4"
              for="description"
            >
              <h4>Description</h4>
            </label>
            <div class="flex-grow-1 h4 mt-n2">
              <v-textarea
                v-model="item.description"
                outlined
                dense
              ></v-textarea>
            </div>
          </div>
          <div class="form-item d-flex pt-5">
            <label
              class="w-174px mr-6px flex-shrink-0 h4"
              for="call-to-action"
            >
              <h4>Call To Action</h4>
            </label>
            <div class="flex-grow-1 h4 mt-n2">
              <v-text-field
                v-model="item.call_to_action"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>
          <div class="form-item d-flex pt-5">
            <label
              class="w-174px mr-6px flex-shrink-0 h4"
              for="link-to-bu-page"
            >
              <h4>Link To BU Page</h4>
            </label>
            <div class="flex-grow-1 h4 mt-n2">
              <v-autocomplete
                v-model="item.bu_id"
                :items="buTabs"
                placeholder="請選擇連結的BU"
                item-text="name"
                item-value="id"
                outlined
                dense
              >
              </v-autocomplete>
            </div>
          </div>
          <div class="form-item d-flex py-5">
            <div class="w-180px mr-6px flex-shrink-0 ">
              <div class="h4" style="margin-bottom: 10px">
                <h4>BU Visual Product Shot</h4>
              </div>
              <div class="h5 ink-02-medium--text font-weight-regular">
                建議尺寸：1080px * 1080px <br />
                檔案大小限制：≤ 20 MB <br />
                支援格式：.png/.jpg/.gif <br />
              </div>
            </div>
            <div class="flex-grow-1 d-flex">
              <ImgUploader class="ml-auto"
                           :imageUrl.sync="item.visual_product_shot"
                           dir="homepage"></ImgUploader>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加BU Section</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    homepage: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
  },
  computed: {
    ...mapState(['buTabs']),
  },
  methods: {
    addItem() {
      const template = {
        title: '',
        description: '',
        call_to_action: '',
        visual_product_shot: '',
      };
      this.homepage.sections.push(template);
    },
    deleteItem(item) {
      const index = this.homepage.sections.map((i) => i.id).indexOf(item.id);
      this.homepage.sections.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.homepage.sections.length - 1) {
        this.homepage.sections.splice(i, 1);
        this.homepage.sections.unshift(item);
        return;
      }
      // item become next index
      this.homepage.sections.splice(i, 1);
      this.homepage.sections.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.homepage.sections.splice(i, 1);
        this.homepage.sections.push(item);
        return;
      }
      // item become previous index
      this.homepage.sections.splice(i, 1);
      this.homepage.sections.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
